export default (params) => ({
  trigger: {
    name: 'last_order_block.select_product',
    params: params,
  },
  config: {
    schema: {
      method: {
        enum: [
          'title',
          'image',
        ],
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: null,
        index: null,
        total_indices: null,
      },
    },
  },
});
